// Centralized "error filter" for TracPatch ROM-style records (raw ROM events
// and per-set exercise results). Single source of truth — all admin charts
// that aggregate flexion/extension data run records through this so we don't
// have drift between charts on what counts as a junk reading.
//
// Rules (a record is INVALID when ANY of):
//   - flexion is missing / null
//   - extension is missing / null
//   - flexion > MAX_FLEX_DEG          (knee can't bend past this clinically)
//   - extension < MIN_EXT_DEG         (excessive hyperextension / sensor drift)
//   - (flexion - extension) < MIN_RANGE_DEG  (limb didn't actually move)
//
// Naming convention on a record:
//   - tracpatchroms documents:           { flexion, extension }
//   - tracpatchexerciseresults documents: { peakFlexion, peakExtension }
// Use the matching field-aware helper below.

export const MAX_FLEX_DEG  = 135
export const MIN_EXT_DEG   = -10
export const MIN_RANGE_DEG = 5

// Bare value check — both fields required.
export function isValidReading(flex, ext) {
  if (flex == null || ext == null) return false
  if (flex > MAX_FLEX_DEG) return false
  if (ext < MIN_EXT_DEG) return false
  if (flex - ext < MIN_RANGE_DEG) return false
  return true
}

// Record-level helper for `tracpatchroms` (per-event/per-test) docs.
export function isValidRomRecord(rec) {
  if (!rec) return false
  return isValidReading(rec.flexion, rec.extension)
}

// Record-level helper for `tracpatchexerciseresults` (per-set) docs. The set's
// peak flexion + peak extension are the reading of record for the exercise
// chart aggregation.
export function isValidExerciseRecord(rec) {
  if (!rec) return false
  return isValidReading(rec.peakFlexion, rec.peakExtension)
}

// For diagnostics / chart legends if needed later.
export const ERROR_RULES_LABEL =
  `flexion ≤ ${MAX_FLEX_DEG}°, extension ≥ ${MIN_EXT_DEG}°, range ≥ ${MIN_RANGE_DEG}°`
